import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import createStore from '../../../store/index';
import accountPropTypes from '../../../states/accounts/propTypes';
import payeesPropTypes from '../../../states/payees/propTypes';
import sessionPropTypes from '../../../states/session/propTypes';
import envConfigPropTypes from '../../../states/envConfig/propTypes';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import { pages } from '../../../states/page/actions';

class App extends Component {
	constructor(props) {
		super(props);
		const { session, accounts, payees, envConfig, user } = this.props;
		this.store = createStore({
			session,
			accounts,
			payees,
			envConfig,
			user,
			page: { name: pages.RetailPayment },
		});
	}

	render() {
		const { envConfig } = this.props;

		return (
			<Provider store={this.store}>
				<div className="web-ui-components">
					<WebUIThemeProvider brandID={envConfig.brandId}>
						<LayoutContainer />
					</WebUIThemeProvider>
				</div>
			</Provider>
		);
	}
}

App.propTypes = {
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	payees: PropTypes.arrayOf(PropTypes.shape(payeesPropTypes)),
	session: PropTypes.shape(sessionPropTypes).isRequired,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	user: PropTypes.shape({ id: PropTypes.string }),
};

export default App;
